<template>
	<div id="app">
		<el-container>
			<el-aside>
				<el-divider content-position="left">常用</el-divider>
				<el-button type="primary" size="small" icon="el-icon-time" @click="nowTool='time'">时间戳转换</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-json1" @click="nowTool='json'">JSON 格式化</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-zhengzeshi" @click="nowTool='regular'">正则测试</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-zhengzeshi" @click="nowTool='urlEnToDe'">URL解码/编码</el-button>
				<el-divider content-position="left">基础</el-divider>
				<el-button type="primary" size="small" icon="iconfont icon-zifuchuan1" @click="nowTool='string'">字符串工具</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-uuidhuitian" @click="nowTool='uuid'">UUID</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-shanchuhang2" @click="nowTool='nullStringDel'">空行删除</el-button>
			</el-aside>
			<el-container class="main-container">
				<el-header>GetApi</el-header>
				<el-main>
					<el-row>
						<el-col class="card-col" v-if="nowTool=='uuid'">
							<el-card>
								<div class="card-title">UUID</div>
								<GUUid />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='time'">
							<el-card>
								<div class="card-title">时间戳转换</div>
								<GTimeFormat />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='json'">
							<el-card>
								<div class="card-title">
									JSON 格式化插件
								</div>
								<GJSONFormat />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='string'">
							<el-card>
								<div class="card-title">
									文本工具
								</div>
								<GTextTool />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='regular'">
							<el-card>
								<div class="card-title">
									正则测试
								</div>
								<GRegular />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='nullStringDel'">
							<el-card>
								<div class="card-title">
									空行删除
								</div>
								<gNullStringDel />
							</el-card>
						</el-col>
						<el-col class="card-col" v-if="nowTool=='urlEnToDe'">
							<el-card>
								<div class="card-title">
									URL解码/编码
								</div>
								<gUrlEnToDe />
							</el-card>
						</el-col>
					</el-row>
				</el-main>
				<!-- <el-footer>Footer</el-footer> -->
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import GUUid from "./components/g-uuid/g-uuid";
	import GTimeFormat from "./components/g-timeFormat/g-timeFormat";
	import GJSONFormat from "./components/g-jsonformat/g-jsonformat";
	import GTextTool from "./components/g-textTool/g-textTool";
	import GRegular from "./components/g-regular/g-regular";
	
	import gNullStringDel from "./components/g-nullStringDel";
	import gUrlEnToDe from "./components/g-urlEnToDe";
	
	export default {
		name: "app",
		components: {
			GUUid,
			GTimeFormat,
			GJSONFormat,
			GTextTool,
			GRegular,
			gNullStringDel,
			gUrlEnToDe
		},
		data() {
			return {
				nowTool: ''
			}
		}
	};
</script>

<style lang="scss" scoped>
	#app {
		width: 100%;
		height: 100%;
	}
	
	.main-container{
		overflow: hidden;
	}
	.el-container {
		height: 100%;
	}

	.el-header,
	.el-footer {
		color: #333;
		text-align: center;
		line-height: 60px;
		// background-color: #b3c0d1;
		background-color: #fff;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	/deep/ .el-button-group+.el-button-group{
		margin-left: 15px;
	}

	/deep/ .el-aside {
		/* background-color: #d3dce6; */
		color: #333;
		text-align: center;
		/* line-height: 200px; */
		padding: 10px 20px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		width: 250px;

		.el-button {
			// width: 45%;
			width: 100%;
			margin-top: 10px;
			margin-left: 0px;
			margin-right: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		
		.icon-json1{
			font-size: 12px;
			margin-right: 5px;
		}
		.icon-zhengzeshi{
			font-size: 13px;
			margin-right: 5px;
		}
		.icon-zifuchuan1{
			font-size: 14px;
			margin-right: 5px;
		}
		.icon-uuidhuitian{
			font-size: 13px;
			margin-right: 5px;
		}
		.icon-shanchuhang2{
			margin-right: 5px;
		}
	}

	/deep/ .el-header {}

	/deep/ .el-main {

		>.el-row {
			height: 100%;
			width: 100%;

			>.card-col {
				// margin-bottom: 15px;
				height: 100%;

				>.el-card {
					height: 100%;

					>.el-card__body {
						height: 100%;
						display: flex;
						flex-flow: column;
						overflow: auto;
						
						>div:not(.card-title){
							flex: 1;
						}
					}
				}
			}
		}


		.card-title {
			margin-bottom: 15px;
			text-align: center;
		}

		.g-card {
			width: 100%;
			min-width: 354px;
			box-sizing: border-box;
			margin: 0 auto;
			position: relative;
			margin-top: 15px;
			padding: 15px;
			border: 2px dashed #ebebeb;
			border-radius: 4px;
			background-color: #fafafa;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}
		.g-card .copy {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}
</style>
